import { Stack } from "@mui/material";
import { type FC } from "react";

import { EventSectionTitle } from "~/feature/event/components/EventSectionTitle";
import { EventPageSections } from "~/feature/event/constants";

import * as Styled from "./Intro.styles";

interface IIntroProps {
  content?: string | null;
  title?: string;
  id: EventPageSections;
}

export const Intro: FC<IIntroProps> = ({ content, title, id }) => {
  const text = content?.trim() ?? "";

  if (!text) {
    return null;
  }

  return (
    <Stack sx={{
      gap: 1.5
    }}>
      <EventSectionTitle>{title ?? "Intro"}</EventSectionTitle>
      <Styled.Root component="section" id={id}>
        <Styled.Paragraph component="p" variant="caption">
          {text}
        </Styled.Paragraph>
      </Styled.Root>
    </Stack>
  );
};
